import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
    numberOfFloor?: number;
};

export function UnitTypeFloorDetail({ numberOfFloor }: Props) {
    const { t } = useTranslation();
    return (
        <div className={"text-sm"}>
            {t(`unitPage.header.level`, {
                count: numberOfFloor,
            })}
        </div>
    );
}
